import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QuantityCard from '../../components/SupplierBidComponents/QuantityCard';
import {
  ArrowTopRightOnSquareIcon,
  PaperAirplaneIcon,
} from '@heroicons/react/24/outline';
import QuoteInformationCard from '../../components/QuoteReviewComponents/QuoteInformationCard/QuoteInformationCard';
import DefaultModal from '../../components/modals/DefaultModal';

const BidSubmitMakersharkScreen = ({ handleTabChange }) => {
  const user = useSelector((state) => state?.authReducer?.user);
  const [comment, setComment] = useState('');
  const [showModal, setShowModal] = useState(false);
  const quoteNo = 12354;

  const handleCommentSubmit = () => {
    // setting comment data
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-row w-full space-x-3">
        <img
          alt="Logo"
          src="/Rectangle_107.png"
          className="rounded-lg w-96 h-[267px]"
        />
        <div className="w-full flex-grow">
          <QuoteInformationCard
            type={'quoteInformation'}
            quoteNo={quoteNo}
            supplierReviewScreen={true}
          />
        </div>
      </div>
      <QuantityCard />
      <div className="block p-4 pl-10 border border-[#DDDDDD] rounded-2xl items-center">
        <div className="flex flex-row space-x-4 grid grid-cols-6">
          <div className="tracking-tight text-gray-900 text-[25px] font-bold">
            Subtotal :
          </div>
          <div className="tracking-tight text-gray-900 text-[25px]">$25000</div>
        </div>
      </div>
      <div className="block p-4 pl-10 border border-[#DDDDDD] rounded-2xl items-center space-y-5">
        <div className="flex flex-row justify-between space-x-4">
          <div className="tracking-tight text-gray-900 text-[25px] font-bold">
            Additional Comments :
          </div>
          <ArrowTopRightOnSquareIcon className="w-6 h-6 mt-2" />
        </div>
        <div className="flex flex-row px-5 py-2 border border-neutral-200 rounded-2xl items-center">
          <div>
            <img
              className="h-12 w-12 rounded-full"
              src={user?.picture}
              alt="user"
            />
          </div>
          <div className="flex-grow px-5">
            <input
              type="text"
              name="comment"
              id="comment"
              className="relative px-2 py-1 bg-white w-full rounded-full hover:cursor-pointer text-[13.33px] font-normal focus:outline-none placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:text-[13.33px]"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCommentSubmit();
                }
              }}
              placeholder="Add a suggestion or comment..."
            />
          </div>
          <PaperAirplaneIcon
            className="h-6 w-6 hover:cursor-pointer"
            onClick={() => handleCommentSubmit()}
          />
        </div>
      </div>
      <div className="flex flex-row items-center justify-center space-x-6">
        <button className="rounded-full px-8 py-2 text-[18px] text-center my-1 border-[1px] border-black min-w-[180px]">
          Save
        </button>
        <button
          className="rounded-full px-8 py-2 text-[18px] text-center my-1 bg-blue-400 text-white font-bold min-w-[180px]"
          onClick={() => setShowModal(true)}
        >
          Send Bid
        </button>
        <button
          className="rounded-full px-8 py-2 text-[18px] text-center my-1 border-[1px] border-black min-w-[180px]"
          onClick={() => handleTabChange('select_supplier')}
        >
          Previous Page
        </button>
      </div>
      {showModal && (
        <DefaultModal
          heading="Congratulations!"
          MainData="Your Quote 12345 has been Successfully submitted"
          SecondaryData="We will get back to you in 24 hours."
          ReturnTitle="Return to Dashboard"
          ButtonTitle="Dashboard"
          ButtonLink=""
        />
      )}
    </div>
  );
};

export default BidSubmitMakersharkScreen;
